const BackIconInBlack = () => {
    return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="10"
          height="16"
          viewBox="0 0 8 13"
          fill="none"
        >
          <path
            d="M7 12L1.69325 6.69325C1.61514 6.61514 1.61514 6.48851 1.69325 6.41041L7 1.10366"
            stroke="black"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </svg>
    );
  };
  export default BackIconInBlack;
  